import { useMemo } from 'react'
import { t } from '@lingui/macro'
import { useLingui } from '@lingui/react'
import { useIsUS } from '@/hooks/useIsUS'
import { compact } from 'lodash'

export type FieldGroups = Array<{
  title: string
  fields: Array<{ key: string; label: string }>
}>

export const useFieldGroups = () => {
  const isUS = useIsUS()
  const lingui = useLingui()

  return useMemo(
    () =>
      compact([
        {
          title: lingui._(t`Personal Information`),
          fields: [
            { key: 'userInfo_fullName', label: lingui._(t`Full name`) },
            { key: 'userInfo_birthday', label: lingui._(t`Birthday`) },
            { key: 'userInfo_gender', label: lingui._(t`Gender`) },
          ],
        },
        {
          title: lingui._(t`Contact Information`),
          fields: [
            { key: 'email', label: lingui._(t`Email`) },
            { key: 'contactInfo_phone', label: lingui._(t`Phone`) },
            { key: 'contactInfo_street', label: lingui._(t`Street`) },
            { key: 'contactInfo_city', label: lingui._(t`City`) },
            { key: 'contactInfo_cp', label: lingui._(t`Postal code`) },
            { key: 'contactInfo_country', label: lingui._(t`Country`) },
          ],
        },
        {
          title: lingui._(t`Medical Information`),
          fields: compact([
            !isUS && { key: 'secu', label: lingui._(t`Social security number`) },
            { key: 'agreement', label: lingui._(t`Agreement`) },
            { key: 'allergy', label: lingui._(t`Allergy`) },
            { key: 'background', label: lingui._(t`Background`) },
            { key: 'vaccins', label: lingui._(t`Vaccines`) },
            { key: 'treatment', label: lingui._(t`Treatment`) },
            { key: 'height', label: lingui._(t`Height`) },
            { key: 'weight', label: lingui._(t`Weight`) },
            { key: 'notes', label: lingui._(t`Notes`) },
          ]),
        },
        {
          title: lingui._(t`Attending Physician Information`),
          fields: [
            { key: 'attendingPhysician_firstname', label: lingui._(t`First name`) },
            { key: 'attendingPhysician_lastname', label: lingui._(t`Last name`) },
            { key: 'attendingPhysician_email', label: lingui._(t`Email`) },
            { key: 'attendingPhysician_phone', label: lingui._(t`Phone`) },
            { key: 'attendingPhysician_city', label: lingui._(t`City`) },
            { key: 'attendingPhysician_street', label: lingui._(t`Street`) },
            { key: 'attendingPhysician_cp', label: lingui._(t`Postal code`) },
          ],
        },
        isUS && {
          title: lingui._(t`Insurance Information`),
          fields: [
            { key: 'primaryPolicy', label: lingui._(t`Primary policy`) },
            { key: 'secondaryPolicy', label: lingui._(t`Secondary policy`) },
            { key: 'insured', label: lingui._(t`Insured name`) },
            { key: 'insuredRelationship', label: lingui._(t`Insured relationship`) },
            { key: 'insuranceProvider', label: lingui._(t`Insurance provider`) },
            { key: 'primaryInsurance', label: lingui._(t`Primary insurance`) },
            { key: 'secondaryInsurance', label: lingui._(t`Secondary insurance`) },
            { key: 'primaryPharmacy', label: lingui._(t`Primary pharmacy`) },
          ],
        },
      ]),
    [isUS, lingui]
  )
}
